import styled, { css } from 'styled-components';
import { colors, devices } from '../../../base/styled/variables.styled';
import { typography, fontWeights } from '../../../base/styled/typography.style';
export const HistoricEnrollmentCardContainer = styled.article `
  display: grid;
  grid-template-columns: 260px 1fr 300px;
  grid-template-areas: "image content meta";
  gap: 16px;
  border-radius: 8px;
  background-color: ${({ $inverse }) => $inverse ? colors.brand500 : 'transparent'};
  overflow: hidden;
  width: 100%;

  &:hover {
    background-color: ${({ $inverse }) => $inverse ? colors.brand800 : colors.brand75};
  }

  @media ${devices.tablets} {
    grid-template-columns: 260px 1fr;
    grid-template-rows: auto auto;
    grid-template-areas: 
      "image content"
      "image meta";
  }

  @media ${devices.mobile} {
    display: flex;
    flex-direction: column;
  }
`;
export const CardTitle = styled.h3.withConfig({
    shouldForwardProp: (prop) => !['inverse', '$inverse'].includes(prop),
}) `
  ${css(typography.headline4)}
  font-weight: ${fontWeights.regular};
  margin: 0;
  color: ${({ $inverse }) => $inverse ? colors.neutral000 : colors.neutral800};

  strong {
    font-weight: ${fontWeights.bold};
    color: ${({ $inverse }) => $inverse ? colors.neutral000 : colors.neutral800};
  }
`;
export const ImageColumn = styled.div `
  grid-area: image;
  width: 260px;
  height: 180px;
  border-radius: 8px;
  overflow: hidden;
  flex-shrink: 0;

  @media ${devices.mobile} {
    width: 100%;
    height: auto;
    aspect-ratio: 16/9;
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;
export const ContentColumn = styled.div `
  grid-area: content;
  padding: 16px 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;

  @media ${devices.tablets} {
    padding: 16px 16px 0 0;
  }

  @media ${devices.mobile} {
    padding: 16px;
  }

  > * {
    margin: 0 !important;
  }
`;
export const MetaColumn = styled.div.withConfig({
    shouldForwardProp: (prop) => !['inverse', '$inverse'].includes(prop),
}) `
  grid-area: meta;
  padding: 16px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  border-left: 1px solid ${({ $inverse }) => $inverse ? colors.brand300 : colors.neutral300};

  @media ${devices.tablets} {
    border-left: none;
    padding: 0 16px 16px 0;
  }

  @media ${devices.mobile} {
    padding: 0 16px 16px 16px;
  }
`;
export const InfoItemsContainer = styled.div `
  display: flex;
  flex-direction: column;
  gap: 4px;
`;
export const InfoItem = styled.div `
  display: flex;
  align-items: center;
  gap: 4px;
  ${typography.body3};
  color: ${({ $inverse }) => $inverse ? colors.neutral000 : colors.neutral500};

  svg {
    width: 16px;
    height: 16px;
    fill: ${({ $inverse }) => $inverse ? colors.neutral000 : colors.brand500};
  }
`;
export const MetaInfo = styled.div `
  display: flex;
  flex-direction: column;
  gap: 4px;
`;
export const StatusText = styled.div `
  ${typography.body3};
  color: ${({ $inverse }) => $inverse ? colors.neutral000 : colors.neutral500};
  
  strong {
    ${typography.body3Highlight};
    color: ${({ $inverse }) => $inverse ? colors.neutral000 : colors.neutral500};
  }
`;
export const DateText = styled.div `
  ${typography.body3};
  color: ${({ $inverse }) => $inverse ? colors.neutral000 : colors.neutral500};

  strong {
    ${typography.body3Highlight};
    color: ${({ $inverse }) => $inverse ? colors.neutral000 : colors.neutral500};
  }
`;
export const Progress = styled.div `
  ${typography.body3};
  color: ${({ $inverse }) => $inverse ? colors.neutral000 : colors.neutral500};
  margin-bottom: 4px;

  strong {
    ${typography.body3Highlight};
    color: ${({ $inverse }) => $inverse ? colors.neutral000 : colors.neutral500};
  }
`;
export const ButtonWrapper = styled.div `
  margin-top: auto;
  width: 100%;
`;
//# sourceMappingURL=HistoricEnrollmentCard.style.js.map